import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ThemeEnum } from '@app/common';
import { useTheme } from 'styled-components';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { PortfolioMobxDto } from '../../../../../../models/mobx/dtos/portfolio/portfolio-mobx-dto';
import { AssetPortfolioSimple } from '../asset-portfolio-simple';
import { getOpacity } from '../../../../../../theme/utils/get-rgb';

type AssetPortfolioSimpleSummaryType = {
    data: PortfolioMobxDto;
    disabled?: boolean;
    onClick?: () => void;
};

export const AssetPortfolioSimpleSummary: React.FC<AssetPortfolioSimpleSummaryType> = observer(
    ({ data, disabled = false, onClick }: AssetPortfolioSimpleSummaryType) => {
        const { themeStore } = useRootStore();
        const { t } = useTranslation();
        const theme = useTheme();
        const isActive = data.selected;

        const baseColor =
            themeStore.theme === ThemeEnum.Light
                ? theme.assetColor[data.colorName].dark
                : theme.assetColor[data.colorName].light;

        return (
            <div
                className={`relative mt-[2rem] flex min-w-[22rem] items-center justify-between gap-[1rem] rounded-[99rem] p-[0.8rem] pr-medium ${
                    isActive ? 'cursor-default' : 'cursor-pointer'
                }`}
                style={{
                    backgroundColor: isActive
                        ? theme.assetColor[data.colorName].activeBackground
                        : getOpacity(theme.assetColor[data.colorName].main, 0.1),
                    color: isActive ? theme.assetColor[data.colorName].text : baseColor,
                    boxShadow: `inset 0 0.1rem 0.1rem ${getOpacity(theme.assetColor[data.colorName].main, 0.1)}`,
                }}
                onClick={onClick}
            >
                <AssetPortfolioSimple disabled={disabled} data={data} />
                <div
                    className="absolute top-0 right-[2.5rem] -translate-y-1/2 whitespace-nowrap rounded-[20rem] px-[0.8rem] py-[0.4rem] text-[1.1rem] font-bold uppercase leading-[1.1rem] shadow-large"
                    style={{
                        backgroundColor: theme.assetColor[data.colorName].darken,
                        color: theme.assetColor[data.colorName].text,
                    }}
                >
                    {t('layout.tables.portfolios.summaryPortfolioShort')}
                </div>
            </div>
        );
    },
);
